/**
 * The ACOT Orders Tracker lives in its own app on its own host now (netcup),
 * not behind sundae's `#/orders` sub-view. Anything in sundae that points at a
 * journey, a release or a package is therefore a cross-app link: absolute URL,
 * new tab.
 *
 * One constant so the cutover (and any future host move) is a one-line edit.
 * Routes come from the orders app's `src/app/routes.tsx`.
 */
export const ORDERS_APP_URL = 'https://orders.acot.site';

/** `/journeys/:id` — the expanded journey. */
export function ordersJourneyUrl(journeyId: number | string): string {
  return `${ORDERS_APP_URL}/journeys/${encodeURIComponent(String(journeyId))}`;
}

/** `/packages` — the packages feed; there is no per-package route. */
export function ordersPackagesUrl(): string {
  return `${ORDERS_APP_URL}/packages`;
}
